import React from 'react';
import { Container, Typography, Paper, Grid, Box } from '@mui/material';
import { CheckCircleOutline, Timeline, emoji_events } from '@mui/icons-material';

const HowItWorks: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h3" gutterBottom fontWeight="bold" color="primary">How It Works</Typography>

                <Box sx={{ mt: 4 }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="h5" fontWeight="bold" gutterBottom>1. Track Your Progress</Typography>
                                <Typography>Simply mark topics as complete as you learn them in class. Watch your progress bars grow!</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="h5" fontWeight="bold" gutterBottom>2. Set Your Goals</Typography>
                                <Typography>Define what you want to achieve. Whether it's passing a module or acing the exam, we help you stay focused.</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="h5" fontWeight="bold" gutterBottom>3. Earn Rewards</Typography>
                                <Typography>Gain points and badges for your consistency. Learning is a journey, and we celebrate every step.</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </Container>
    );
};
export default HowItWorks;
